import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { getIcon } from 'entities/settings-master/ui/icons';
import * as S from './style';
function ButtonCardImpl(props) {
    const { card, nextBoard, path } = props;
    return (_jsx(Card, { variant: "outlined", sx: {
            width: isMediumUI() ? '50%' : '100%',
            maxHeight: 500,
            borderRadius: '4px',
            '& .MuiPaper-root': {
                display: 'flex',
                flexFlow: 'column nowrap',
            },
            '& .MuiCardActions-root': {
                justifyContent: 'center',
            },
        }, children: _jsx(CardContent, { sx: { flexGrow: 1, p: 0, px: 2 }, children: _jsxs(S.Card, { onClick: nextBoard, children: [_jsx("div", { style: { maxWidth: '300px' }, children: getIcon(card.name, path) }), _jsxs(CardContent, { sx: {
                            flexGrow: 1,
                            padding: 0,
                            paddingTop: 2,
                        }, children: [_jsx(Typography, { variant: "subtitle1", color: "secondary.main", children: _jsx("strong", { children: card.title }) }), _jsx(Box, { overflow: "auto", pt: 1, children: _jsx(Typography, { variant: "body1", sx: {
                                        minWidth: '100%',
                                        overflowY: 'auto',
                                        height: '120px',
                                    }, children: card.description(path) }) })] })] }) }) }));
}
export const ButtonCard = memo(ButtonCardImpl);
